import script from "./ReferenceView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceView.vue?vue&type=script&setup=true&lang=js"

import "./ReferenceView.vue?vue&type=style&index=0&id=6ca92708&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ca92708"]])

export default __exports__